import _objectSpread from "/tmp/build_0e5801b9/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
/**
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').Join} Join
 * @typedef {import('../types.js').Context} Context
 * @typedef {import('../types.js').TrackFields} TrackFields
 */

import { track } from './track.js';

/**
 * @param {Parent} parent
 * @param {Context} context
 * @param {TrackFields} safeOptions
 * @returns {string}
 */
export function containerFlow(parent, context, safeOptions) {
  var indexStack = context.indexStack;
  var children = parent.children || [];
  var tracker = track(safeOptions);
  /** @type {Array<string>} */
  var results = [];
  var index = -1;
  indexStack.push(-1);
  while (++index < children.length) {
    var child = children[index];
    indexStack[indexStack.length - 1] = index;
    results.push(tracker.move(context.handle(child, parent, context, _objectSpread({
      before: '\n',
      after: '\n'
    }, tracker.current()))));
    if (child.type !== 'list') {
      context.bulletLastUsed = undefined;
    }
    if (index < children.length - 1) {
      results.push(tracker.move(between(child, children[index + 1])));
    }
  }
  indexStack.pop();
  return results.join('');

  /**
   * @param {Node} left
   * @param {Node} right
   * @returns {string}
   */
  function between(left, right) {
    var index = context.join.length;
    while (index--) {
      var result = context.join[index](left, right, parent, context);
      if (result === true || result === 1) {
        break;
      }
      if (typeof result === 'number') {
        return '\n'.repeat(1 + result);
      }
      if (result === false) {
        return '\n\n<!---->\n\n';
      }
    }
    return '\n\n';
  }
}